// FEED API client. Read-only, mirrors FinanceService's auth pattern. The /feed
// payload is already tray-shaped (see FOCUS / STREAM in serga-os/data.js): the
// upper "Today's Focus" board (agent-written) + the lower Mastodon home-timeline
// stream (TTL-cached server-side). Either half may be { pending: true }.

const API_BASE_URL = "https://api.serga.ba";

export interface FocusItem {
  id: string;
  type: "event" | "email" | "task" | "note";
  title: string;
  meta?: string;
  src?: string;
  urgent?: boolean;
}

export interface FocusView {
  rev: string;
  period?: string;
  curator?: string;
  updatedAt: string;
  items: FocusItem[];
  pending?: boolean;
}

export interface StreamPost {
  id: string;
  author: string;
  boostedBy?: string | null;
  text: string;
  likes: number;
  replies: number;
  reblogs?: number;
  permalink: string | null;
  createdAt: string;
}

export interface StreamView {
  source?: string;
  account?: string | null;
  handle?: string;
  fetchedAt?: string;
  items: StreamPost[];
  stale?: boolean;
  pending?: boolean;
  error?: boolean | string;
}

export interface FeedView {
  focus: FocusView | { pending: true };
  stream: StreamView | { pending: true } | { error: true };
}

export class FeedService {
  private static authTokens: any = null;

  static setAuthTokens(tokens: any) {
    this.authTokens = tokens;
  }

  private static getAuthHeaders() {
    if (!this.authTokens?.idToken) {
      throw new Error("No authentication token available");
    }
    return {
      Authorization: `Bearer ${this.authTokens.idToken}`,
      "Content-Type": "application/json",
    };
  }

  /**
   * Live FEED payload { focus, stream }, or null on failure so the caller keeps
   * its fixtures. The stream's `account` is surfaced as the section `handle`.
   */
  static async getFeed(): Promise<FeedView | null> {
    const res = await fetch(`${API_BASE_URL}/feed`, {
      headers: this.getAuthHeaders(),
    });
    if (!res.ok) throw new Error(`Request failed: ${res.status}`);
    const data = await res.json();
    if (data?.stream && data.stream.account && !data.stream.handle) {
      data.stream.handle = data.stream.account;
    }
    return data as FeedView;
  }
}
